import * as React from 'react'
import { SVGProps } from 'react'
export const HeartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    {...props}
  >
    <path
      fill="#858585"
      d="m21.175 32.462-.175.175-.192-.175C12.495 24.92 7 19.932 7 14.875c0-3.5 2.625-6.125 6.125-6.125 2.695 0 5.32 1.75 6.247 4.13h3.256c.927-2.38 3.552-4.13 6.247-4.13 3.5 0 6.125 2.625 6.125 6.125 0 5.058-5.495 10.045-13.825 17.587Zm7.7-27.212c-3.045 0-5.968 1.418-7.875 3.64-1.907-2.223-4.83-3.64-7.875-3.64-5.39 0-9.625 4.217-9.625 9.625 0 6.598 5.95 12.005 14.962 20.178L21 37.363l2.538-2.31C32.55 26.88 38.5 21.473 38.5 14.875c0-5.408-4.235-9.625-9.625-9.625Z"
    />
  </svg>
)
